import React from 'react';
import { cn } from '@/utils/tailwind';
import AlertIcon from '@/assets/icons/OrderDetails/eva_alert-triangle-fill.svg?react';

interface BadgeProps {
  color: 'gr' | 'red' | 'point';
  children: React.ReactNode;
  className?: string;
}

export const TimeBadge: React.FC<BadgeProps> = ({ color, children, className }) => {
  let colorClass = '';
  switch (color) {
    case 'gr':
      colorClass = 'bg-gr-100 text-gr-600';
      break;
    case 'red':
      colorClass = 'bg-red-100 text-red-400';
      break;
    case 'point':
      colorClass = 'bg-point-100 text-point-500';
      break;
    default:
      colorClass = '';
  }

  return (
    <span
      className={cn(
        'flex items-center gap-[2px] rounded-[8px] px-[6px] py-[2px] Caption1M12',
        colorClass,
        className,
      )}
    >
      {color === 'red' && <AlertIcon />}
      <span className="max-w-[80px] truncate whitespace-nowrap">{children}</span>
    </span>
  );
};
